import i18nRegister from '../../../juristec-ui/utils/language/i18nRegister';
import enModifier from './enModifier.json';
import ptModifier from './ptModifier.json';
import esModifier from './esModifier.json';

export default function registerNamespaceModifier(path: string) {
  return i18nRegister<keyof typeof ptModifier>(path, {
    en: enModifier, pt: ptModifier, es: esModifier,
  });
}
